import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change:
 * - If URL has a hash (#section), snap the target element to the top of the viewport.
 * - Otherwise, snap the window to the top.
 * "Snap" = instant (no smooth easing), so clicking a nav item feels immediate.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Defer to allow the target section to render
            const id = hash.replace("#", "");
            requestAnimationFrame(() => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ block: "start", behavior: "smooth" });
                    return;
                }
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            });
            return;
        }
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname, hash]);

    return null;
}
